import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  input {
    &::placeholder {
      color: #999;
    }
  }
`;
